function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.95697 2.97921C5.87253 2.61627 5.52653 2.37389 5.1529 2.41594C4.77927 2.458 4.497 2.77109 4.49693 3.14354C4.4969 3.27839 4.38652 3.38769 4.25037 3.38766C4.11423 3.38763 4.00388 3.2783 4.00391 3.14345C4.00403 2.52267 4.47449 2.00083 5.09723 1.93074C5.71997 1.86065 6.29666 2.26462 6.4374 2.86955C6.57815 3.47447 6.23813 4.08769 5.64722 4.29462C5.5487 4.32912 5.48285 4.4214 5.48291 4.52491V4.60837C5.48291 4.74322 5.37254 4.85254 5.23639 4.85254C5.10025 4.85254 4.98988 4.74322 4.98988 4.60837L4.98988 4.52517C4.98988 4.52512 4.98988 4.52521 4.98988 4.52517C4.98977 4.21467 5.18732 3.93771 5.48288 3.83421C5.83741 3.71006 6.04141 3.34215 5.95697 2.97921Z",
  fill: "#4C4C4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.86719 5.81411C4.86719 5.61185 5.03273 5.44788 5.23695 5.44788C5.44116 5.44788 5.60671 5.61185 5.60671 5.81411C5.60671 6.01638 5.44116 6.18035 5.23695 6.18035C5.03273 6.18035 4.86719 6.01638 4.86719 5.81411Z",
  fill: "#4C4C4C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.6961 0.484233C1.4711 0.484233 1.28869 0.664898 1.28869 0.88776V7.34419C1.28869 7.56706 1.4711 7.74772 1.6961 7.74772H2.9998C3.13481 7.74772 3.24425 7.85612 3.24425 7.98984V9.44254L5.46055 7.79614C5.50286 7.76471 5.55432 7.74772 5.60721 7.74772H8.70351C8.92851 7.74772 9.11092 7.56706 9.11092 7.34419V0.88776C9.11092 0.664898 8.92851 0.484233 8.70351 0.484233H1.6961ZM0.799805 0.88776C0.799805 0.397464 1.20109 0 1.6961 0H8.70351C9.19852 0 9.5998 0.397463 9.5998 0.88776V7.34419C9.5998 7.83449 9.19852 8.23195 8.70351 8.23195H5.68869L3.14647 10.1205C3.0724 10.1755 2.9733 10.1843 2.89049 10.1433C2.80767 10.1023 2.75536 10.0185 2.75536 9.92677V8.23195H1.6961C1.20109 8.23195 0.799805 7.83449 0.799805 7.34419V0.88776Z",
  fill: "#4C4C4C"
});

const SvgQuestion = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.8fd9b043.svg";
export { ForwardRef as ReactComponent };